module.exports = __webpack_public_path__ + "img/banner-en-mobile.373c507d.jpg";